import { configureStore } from "@reduxjs/toolkit";
import i18n from "../i18n";

import parentReducer from "../redux/ParentSlice";
import toggleSlice from "../redux/ToggleSlice";
import userSlice from "../redux/UserSlice";
import languageSlice from "../redux/languageSlice";
import adminCredSlice from "../redux/adminCredSlice";
import authSlice from "../redux/AuthSlice";
import teachersSlice from "../redux/teachersSlice";
import studentSlice from "../redux/studentSlice";
import classesSlice from "../redux/classSlice";
import booksSlice from "../redux/booksSlice";
import classSectionsSlice from "../redux/classSectionsSlice";
import subjectsSlice from "../redux/subjectsSlice";
import coursesSlice from "../redux/coursesSlice";
import lessonSlice from "../redux/lessonSlice";
import dashboardSlice from "../redux/dashboardSlice";
import campusesSlice from "../redux/campusesSlice";
import managementSlice from "../redux/managementSlice";
import feesStructuresSlice from "../redux/feeStructureSlice";
import jobsSlice from "../redux/jobsSlice";
import candidateSlice from "../redux/candidateSlice";
import employeeSlice from "../redux/employeeSlice";
import warningSlice from "../redux/warningSlice";
import applyLeaveSlice from "../redux/applyLeaveSlice";
import assignLeaveSlice from "../redux/assignLeaveSlice";
import attendanceSlice from "../redux/attendanceSlice";
import overtimeSlice from "../redux/overtimeSlice";
import timeAdjustmentSlice from "../redux/timeAdjustmentSlice";
import gracePeriodSlice from "../redux/gracePeriodSlice";
import rosterSlice from "../redux/rosterSlice";
import salarySlice from "../redux/salarySlice";
import welfareAllowanceSlice from "../redux/welfareAllowanceSlice";
import stipendSlice from "../redux/stipendSlice";
import taxSlice from "../redux/taxSlice";
import examSlice from "../redux/examSlice";
import loanAdvanceSlice from "../redux/loanAdvanceSlice";
import duesSlice from "../redux/duesSlice";
import interviewSlice from "../redux/interviewSlice";
import notificationsSlice from "../redux/notificationsSlice";
import incidentReportSlice from "../redux/incidentReportSlice"
import studentIncidentReportSlice from "../redux/studentIncidentReportSlice"
import studentProfileReportSlice from "../redux/studentProfileReportSlice"
import arreasDetailsSlice from "../redux/arreasDetailsSlice"
import bonusSlice from "../redux/bonusSlice"
import allowanceSlice from "../redux/allowanceSlice"
import hrConfigSlice from "../redux/hrConfigSlice";
import sessionSlice from "../redux/sessionSlice";
import fineSlice from "../redux/fineSlice";
import leaveSlice from "../redux/leaveSlice";
import leaveLimitSlice from "../redux/leaveLimitSlice";
import holidaySlice from "../redux/holidaySlice";
import hrWarningSlice from "../redux/hrWarningSlice";
import courseEnrollmentSlice from "../redux/courseEnrollmentSlice";
import departmentSlice from "../redux/departmentSlice";
import companySlice from "../redux/companySlice";
import designationSlice from "../redux/designationSlice";
import locationSlice from "../redux/locationSlice";
import employeeSalarySlice from "../redux/employeeSalarySlice";
import payrollSlice from "../redux/payrollSlice";
import erpSlice from "../redux/erpSlice";
import annualPersonalObjectiveSlice from "../redux/annualPersonalObjectiveSlice";
import performanceReviewSlice from "../redux/performanceReviewSlice";
import annualPersonalDevelopmentPlanSlice from "../redux/annualPersonalDevelopmentPlanSlice";
import administratorSlice from "../redux/administratorSlice";
import goalPlanningSlice from "../redux/goalPlanningSlice";
import adminCheckInSlice from "../redux/adminCheckInSlice";
import siteVisitSlice from "../redux/siteVisitSlice";
import adminObservationSlice from "../redux/adminObservationSlice";
import observationEvaluationSlice from "../redux/observationEvaluationSlice";
import teacherReportSlice from "../redux/teacherReportSlice";

export const store = configureStore({
  reducer: {
    toggler: toggleSlice,
    user: userSlice,
    language: languageSlice,
    admincredslice: adminCredSlice,
    auth: authSlice,
    teachers: teachersSlice,
    students: studentSlice,
    parents: parentReducer,
    classes: classesSlice,
    books :booksSlice,
    classSections: classSectionsSlice,
    subjects: subjectsSlice,
    courses: coursesSlice,
    lessons: lessonSlice,
    dashboard: dashboardSlice,
    campuses: campusesSlice,
    management: managementSlice,
    feeStructures: feesStructuresSlice,
    jobs: jobsSlice,
    candidates: candidateSlice,
    employees: employeeSlice,
    warnings: warningSlice,
    leaves: applyLeaveSlice,
    assignLeave: assignLeaveSlice,
    attendance: attendanceSlice,
    overtime: overtimeSlice,
    timeAdjustments: timeAdjustmentSlice,
    gracePeriods: gracePeriodSlice,
    rosters: rosterSlice,
    salaries: salarySlice,
    welfareAllowance: welfareAllowanceSlice,
    stipends: stipendSlice,
    taxes: taxSlice,
    exam: examSlice,
    loanAdvances: loanAdvanceSlice,
    dues: duesSlice,
    interviews: interviewSlice,
    notifications: notificationsSlice,
    incidentReports: incidentReportSlice,
    studentIncidentReport: studentIncidentReportSlice,
    studentProfileReport: studentProfileReportSlice,
    arreasDetails: arreasDetailsSlice,
    bonuses: bonusSlice,
    allowances: allowanceSlice,
    hrConfig: hrConfigSlice,
    sessions: sessionSlice,
    fines: fineSlice,
    leaveTypes: leaveSlice,
    leaveLimits: leaveLimitSlice,
    holidays: holidaySlice,
    hrWarnings: hrWarningSlice,
    courseEnrollment: courseEnrollmentSlice,
    companies: companySlice,
    departments: departmentSlice,
    designations: designationSlice,
    locations: locationSlice,
    employeeSalaries: employeeSalarySlice,
    payroll: payrollSlice,
    lmsEmployees: erpSlice,
    annualPersonalObjective: annualPersonalObjectiveSlice,
    performanceReview: performanceReviewSlice,
    annualPersonalDevelopmentPlan: annualPersonalDevelopmentPlanSlice,
    administrators: administratorSlice,
    goalPlanning: goalPlanningSlice,
    adminCheckIn: adminCheckInSlice,
    siteVisit: siteVisitSlice,
    adminObservation: adminObservationSlice,
    observationEvaluation: observationEvaluationSlice,
    teacherReport: teacherReportSlice,
  },
});

let previousLanguageCode = store.getState().language.code;

store.subscribe(() => {
  const state = store.getState();
  const currentLanguageCode = state.language.code;

  if (previousLanguageCode !== currentLanguageCode) {
    i18n.changeLanguage(currentLanguageCode);
    previousLanguageCode = currentLanguageCode; 
  }
});
